export default "__VITE_ASSET__DKvaW9sb__"